// URGENT: do not add any 3rd party dependency for manipulating date time in this file

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const getISTDateFromIsoDate = (dateTimeStr: string) => new Date(Date.parse(`${dateTimeStr}+05:30`));

export const getDateDD = (d: Date) => { // return 01 0r 11
  const date = d.getDate();
  const formattedDate = date > 9 ? date : `0${date}`;
  return formattedDate;
};

export const getMonthMmm = (d: Date) => { // this return in format 'Oct'
  const month = months[d.getMonth()];
  return month.slice(0, 3);
};

export const getMonthMM = (d: Date) => { // return 08 for August or 10 for October
  const month = d.getMonth() + 1;
  const formattedMonth = month > 9 ? month : `0${month}`;
  return formattedMonth;
};

export const getAMPM = (hours: number) => {
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  return amOrPm;
};

export const getMinutesMM = (d: Date) => {
  const minutes = d.getMinutes();
  const formattedMinutes = minutes > 9 ? minutes : `0${minutes}`;
  return formattedMinutes;
};

export const getTime12HHMM = (d: Date) => {
  const minutes = getMinutesMM(d);
  const hours = d.getHours();
  let formattedHour = hours > 12 ? hours - 12 : hours;
  formattedHour = formattedHour === 0 ? 12 : formattedHour;
  const amOrPm = getAMPM(hours);
  return `${formattedHour}:${minutes} ${amOrPm}`;
};

export const getAdvancePurchaseDays = (departDate: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneDay = 24 * 60 * 60 * 1000;
  const diff = (departDate.getTime() - today.getTime()) / oneDay;
  return Math.floor(diff);
}
